import { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import {
  Grid,
  Typography,
  Button,
  TextField,
  makeStyles,
  SwipeableDrawer,
  Box,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogContent,
  DialogActions,
  InputAdornment,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import OtpInput from "react-otp-input";
import CloseIcon from "@mui/icons-material/Close";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import {
  get_customer_list,
  save_customer_list,
  customer_registration,
} from "../../utils/customer_helper";
import { set_customer, set_last_order, customer_membership } from "../../store/actions/action";
import { BUTTON_COLOR, TEXT_COLOR } from "../../utils/constant";
import phoneWebSvg from "../../assets/web/phone.svg";

const useStyles = makeStyles(() => ({
  drawerPaper: {
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    overflow: "hidden",
  },
  drawerContent: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
  },
  scrollableContent: {
    flex: 1,
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
    overscrollBehavior: "none",
    paddingBottom: "0.5rem",
  },
  stickyButton: {
    flexShrink: 0,
    backgroundColor: "white",
    borderTop: "1px solid #f0f0f0",
    touchAction: "none",
  },
  main_button: {
    width: "90%",
    padding: "1rem",
    borderRadius: "1rem",
    fontSize: "1.2rem",
    textTransform: "capitalize",
  },
  customInput: {
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#ccc !important',
        borderWidth: '1px !important',
      },
    },
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
}));

const LoginDrawer = function (props) {
  const { reducer, openUserInfo, setOpenUserInfo } = props;
  const { customer } = reducer;
  const storeInfo = props.sessionReducer?.store_details;
  const storeInfoConfig = props.sessionReducer?.store_config;
  const navigate = useNavigate();
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [formValues, setFormValues] = useState({});
  const [errormsg, setErrormsg] = useState(false);
  const [phoneNumbermsg, setPhoneNumbermsg] = useState(false);
  const [verificationnumber, setVerificationnumber] = useState("");
  const [gotVerificationNumber, setGotVerificationNumber] = useState(false);
  const [namefield, setNamefield] = useState(false);
  const [namefieldmsg, setNamefieldmsg] = useState(false);
  const [customerData, setCustomerData] = useState("");
  const [custMoile, setCustMoile] = useState("");
  const [saveCustomer, setSaveCustomer] = useState(false);
  const [preOrder, setPreOrder] = useState({});
  const [customerRegistration, setCustomerRegistration] = useState(false);
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(30);
  const [verificationError, setVerificationError] = useState(false);
  const [emptyVerification, setEmptyVerification] = useState(false);
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  // Track available height as React state so MUI re-renders on keyboard open/close
  const [drawerMaxHeight, setDrawerMaxHeight] = useState(
    window.innerHeight * 0.92
  );

useEffect(() => {
  const updateDrawerHeight = () => {
    // On Android Chrome: window.innerHeight shrinks when keyboard opens.
    // On iOS Safari: window.visualViewport.height shrinks instead.
    // Using the smaller of both covers all cases.
    const vpHeight = window.visualViewport
      ? window.visualViewport.height
      : window.innerHeight;
    const availableHeight = Math.min(vpHeight, window.innerHeight);
    const keyboardHeight = window.screen.height - availableHeight;
    setIsKeyboardOpen(keyboardHeight > 150);
    // Leave a small gap at top (8%) so the drawer doesn't touch screen edge
    setDrawerMaxHeight(availableHeight * 0.92);
  };

  // Run immediately on mount
  updateDrawerHeight();

  // window.resize fires on Android Chrome when keyboard opens/closes
  window.addEventListener("resize", updateDrawerHeight);

  if (window.visualViewport) {
    // visualViewport fires on iOS Safari when keyboard appears
    window.visualViewport.addEventListener("resize", updateDrawerHeight);
    window.visualViewport.addEventListener("scroll", updateDrawerHeight);
  }

  return () => {
    window.removeEventListener("resize", updateDrawerHeight);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener("resize", updateDrawerHeight);
      window.visualViewport.removeEventListener("scroll", updateDrawerHeight);
    }
  };
}, []);

  const sessionReducer = useSelector(state => state.sessionReducer) || {};
  const reduxConfig = sessionReducer.store_config || storeInfoConfig || props.sessionReducer?.store_config || {};

  let menuStore = reduxConfig?.web_ordering_setting?.is_menu || storeInfoConfig?.web_ordering_setting?.is_menu;
  let skipOtp = reduxConfig?.web_ordering_setting?.skip_otp_qr || storeInfoConfig?.web_ordering_setting?.skip_otp_qr;
  let guestCustomer = reduxConfig?.web_ordering_setting?.qr_customer_as_guest || storeInfoConfig?.web_ordering_setting?.qr_customer_as_guest;
  let primaryColor =  reduxConfig?.general_config?.primary_color;
  let secondaryColor =  reduxConfig?.general_config?.secondary_color;

  const orderType = useSelector(state => state.cartReducer?.orderType);
  let type = orderType?.order?.order_type;
  const handleClearField = () => {
    setFormValues({ ...formValues, cust_first_name: "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };


  const resendOTP = () => {
    setMinutes(1);
    setSeconds(0);
    postOTP();
  };

  const SaveUserInfo = async () => {
    if (custMoile?.length !== phoneLength) {
      setPhoneNumbermsg(true);
      return;
    }

    if (!formValues?.cust_first_name) {
      setNamefieldmsg(true);
      return;
    }

    const hasCustomerDetails = customerData?.customer_details?.length > 0;

    if (!hasCustomerDetails && !saveCustomer) {
      if (skipOtp) {
        saveCustomerAPi();
      } else {
        setSaveCustomer(true);
      }
    } else if (hasCustomerDetails) {
      if (skipOtp) {
        saveCustomerAPi();
      } else {
        setCustomerRegistration(true);
        postOTP();
      }
    }
  };



  const saveCustomerAPi = async () => {
    const resp = await save_customer_list({
      ...formValues,
      cust_mobile: custMoile,
    });
    props.set_customer({ ...formValues });
    props?.set_last_order(preOrder);
    if (resp) {
      setSaveCustomer(false);
      let membership = null;
      const sourceObj = preOrder || resp;
      if (sourceObj?.membership) {
        membership = sourceObj.membership;
      } else if (sourceObj?.customer_details?.[0]?.customer_membership) {
        membership = sourceObj.customer_details[0].customer_membership;
      } else if (sourceObj?.order_details?.length) {
        const orderWithMem = sourceObj.order_details.find(o => o.customer_details?.[0]?.customer_membership);
        if (orderWithMem) membership = orderWithMem.customer_details[0].customer_membership;
      }
      if (membership && props.customer_membership) {
        props.customer_membership([membership]);
      }
      props?.set_customer({ ...formValues, ...resp });
      setPhoneNumbermsg("");
      setNamefield("");
      setOpenUserInfo(false); // Close drawer after success
      let isTableMgmt = sessionReducer?.is_fsr === true;
      if (isTableMgmt || props.goToCart) {
        navigate("/cart");
      } else {
        navigate(menuStore ? (isDesktop ? "/menu" : "/menu-items") : "/cart");
      }
    }
  };

  const RegisterCustomer = async () => {
    if (parseInt(verificationnumber) === parseInt(gotVerificationNumber)) {
      setVerificationError(false);
      setCustomerRegistration(false);
      saveCustomerAPi();
    } else {
      if (verificationnumber.trim().length < 6) {
        setEmptyVerification(true);
        setVerificationError(false);
      } else {
        setVerificationError(true);
        setEmptyVerification(false);
      }
    }
  };

  const postOTP = async () => {
    try {
      setMinutes(1);
      setSeconds(0);
      const otp = await customer_registration({
        to_phone_number: custMoile,
      });
      setGotVerificationNumber(otp);
      setCustomerRegistration(true);
      setErrormsg(true);
      setSaveCustomer(false);
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  const fetchData = async () => {
    try {
      const resp = await get_customer_list({ cust_mobile: custMoile });
      setCustomerData(resp);
      setNamefield(true);
      setErrormsg(false);
      let customer = {};
      if (resp?.customer_details?.length) {
        customer = resp;
        setFormValues({ ...formValues, ...customer.customer_details[0] });
        setPhoneNumbermsg(false);
        setPreOrder({ ...customer });
      } else {
        setErrormsg(true);
        setFormValues("");
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  const handleDrawerClose = () => {
    setOpenUserInfo(false);
    setCustomerRegistration(false);
    setFormValues({});
    setCustMoile("");
    setErrormsg(false);
    setNamefield(false);
    setPhoneNumbermsg(false);
    setNamefieldmsg(false);
    setVerificationnumber("");
    setVerificationError(false);
    setEmptyVerification(false);
  };

  useEffect(() => {
    let interval = null;
    if (minutes > 0 || seconds > 0) {
      interval = setInterval(() => {
        if (seconds > 0) {
          setSeconds((prevSeconds) => prevSeconds - 1);
        } else if (minutes > 0) {
          setMinutes((prevMinutes) => prevMinutes - 1);
          setSeconds(59);
        }
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [minutes, seconds]);

  useEffect(() => {
    if (saveCustomer) {
      postOTP();
    }
  }, [saveCustomer]);

  useEffect(() => {
    if (openUserInfo && customer?.cust_mobile) {
      setCustMoile(customer.cust_mobile);
      setFormValues(prev => ({ ...prev, ...customer }));
      setErrormsg(false);
    }
  }, [openUserInfo, customer]);

  const getPhoneLength = (country) => {
    const phoneLengths = {
      "Oman": 8,
      "India": 10,
      "United States": 10,
      "Canada": 10,
      "Dubai": 9,
      "Abu Dhabi": 9,
    };
    return phoneLengths[country] || 10;
  };

  const phoneLength = getPhoneLength(storeInfo?.store_country);

  useEffect(() => {
    if (custMoile?.length === phoneLength) {
      fetchData();
    }
  }, [custMoile]);

  if (isDesktop) {
    return (
      <Dialog
        open={openUserInfo}
        onClose={handleDrawerClose}
        PaperProps={{
          style: {
            borderRadius: "16px",
            padding: "24px 28px",
            maxWidth: "550px",
            width: "100%",
            boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.15)",
          }
        }}
      >
        {!customerRegistration ? (
          <>
            {/* Header Box with Title, Subtitle, Spacing & Full-Width Divider Line */}
            <Box
              style={{
                width: "100%",
                paddingBottom: "16px",
                marginBottom: "20px",
                borderBottom: "1px solid #eaeaea",
              }}
            >
              <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                <Box style={{ flex: 1, paddingRight: "16px" }}>
                  <Typography
                    variant="h6"
                    style={{
                      color: primaryColor || '#EB5C24',
                      fontWeight: 600,
                      fontFamily: "Satoshi",
                      fontSize: "20px",
                      lineHeight: 1.3,
                    }}
                  >
                    Sign In with Phone Number
                  </Typography>
                  <Typography
                    style={{
                      color: '#666666',
                      fontSize: '14px',
                      fontFamily: "Satoshi",
                      marginTop: "1px",
                      lineHeight: 1.4,
                    }}
                  >
                    {storeInfoConfig?.web_ordering_setting?.customer_screen_subline || "Enter your phone no. to proceed."}
                  </Typography>
                </Box>
                <CloseIcon
                  style={{
                    color: primaryColor || '#EB5C24',
                    cursor: "pointer",
                    fontSize: "22px",
                    marginTop: "2px",
                  }}
                  onClick={handleDrawerClose}
                />
              </Box>
            </Box>

            {/* Input Fields Container with Icon Box Styling */}
            <Box display="flex" flexDirection="column">
              {/* Phone Input Box */}
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  height: "48px",
                  marginBottom: "16px",
                  overflow: "hidden",
                  backgroundColor: "white",
                }}
              >
                <Box
                  style={{
                    width: "52px",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid #e0e0e0",
                    flexShrink: 0,
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.7424 14.7553L16.1357 15.3682C16.1357 15.3682 14.6917 16.8239 10.7517 12.849C6.81176 8.87399 8.25575 7.41821 8.25575 7.41821L8.63708 7.03126C9.57974 6.08149 9.66908 4.55536 8.84642 3.44053L7.16643 1.16351C6.14777 -0.2165 4.18111 -0.399148 3.01446 0.77792L0.921135 2.88853C0.343806 3.473 -0.0428584 4.22795 0.00380797 5.06678C0.123807 7.21391 1.08113 11.8315 6.41976 17.219C12.0824 22.9312 17.3957 23.1585 19.5677 22.9528C20.2557 22.8879 20.853 22.5334 21.3343 22.0463L23.2277 20.136C24.5076 18.8466 24.1476 16.6345 22.5103 15.7321L19.9637 14.3264C18.889 13.7351 17.5824 13.9083 16.7424 14.7553Z" fill={primaryColor || '#EB5C24'}/>
                  </svg>
                </Box>
                <input
                  type="number"
                  placeholder="Enter phone number"
                  name="cust_mobile"
                  value={custMoile}
                  onInput={(e) => {
                    e.target.value = Math.max(0, parseInt(e.target.value))
                      .toString()
                      .slice(0, phoneLength);
                  }}
                  onChange={(e) => {
                    setCustMoile(e.target.value);
                    if (e.target.value?.length < phoneLength) {
                      setFormValues({ ...formValues, cust_first_name: "" });
                    }
                  }}
                  style={{
                    flex: 1,
                    border: "none",
                    outline: "none",
                    padding: "0 16px",
                    fontSize: "15px",
                    fontFamily: "Satoshi, sans-serif",
                    color: "#333",
                    height: "100%",
                    backgroundColor: "transparent",
                  }}
                />
              </Box>
              {phoneNumbermsg && (
                <Typography variant="caption" color="error" style={{ marginTop: "-12px", marginBottom: "16px" }}>
                  Phone number is required
                </Typography>
              )}

              {/* Name Input Box */}
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  height: "48px",
                  marginBottom: "16px",
                  overflow: "hidden",
                  backgroundColor: "white",
                }}
              >
                <Box
                  style={{
                    width: "52px",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid #e0e0e0",
                    flexShrink: 0,
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 34 34" fill={primaryColor || '#EB5C24'}>
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.44444 7.55556C9.44444 5.5517 10.2405 3.62991 11.6574 2.21297C13.0744 0.796029 14.9961 0 17 0C19.0039 0 20.9256 0.796029 22.3426 2.21297C23.7595 3.62991 24.5556 5.5517 24.5556 7.55556C24.5556 9.55941 23.7595 11.4812 22.3426 12.8981C20.9256 14.3151 19.0039 15.1111 17 15.1111C14.9961 15.1111 13.0744 14.3151 11.6574 12.8981C10.2405 11.4812 9.44444 9.55941 9.44444 7.55556ZM9.44444 18.8889C6.93962 18.8889 4.53739 19.8839 2.76621 21.6551C0.995037 23.4263 0 25.8285 0 28.3333C0 29.8362 0.597022 31.2776 1.65973 32.3403C2.72243 33.403 4.16377 34 5.66667 34H28.3333C29.8362 34 31.2776 33.403 32.3403 32.3403C33.403 31.2776 34 29.8362 34 28.3333C34 25.8285 33.005 23.4263 31.2338 21.6551C29.4626 19.8839 27.0604 18.8889 24.5556 18.8889H9.44444Z" />
                  </svg>
                </Box>
                <input
                  type="text"
                  placeholder="Enter your name"
                  name="cust_first_name"
                  value={formValues?.cust_first_name || ""}
                  onChange={handleChange}
                  style={{
                    flex: 1,
                    border: "none",
                    outline: "none",
                    padding: "0 16px",
                    fontSize: "15px",
                    fontFamily: "Satoshi, sans-serif",
                    color: "#333",
                    height: "100%",
                    backgroundColor: "transparent",
                  }}
                />
              </Box>
              {(namefieldmsg || errormsg) && (
                <Typography variant="caption" color="error" style={{ marginTop: "-12px", marginBottom: "16px" }}>
                  {namefieldmsg ? "Name is required" : ""}
                </Typography>
              )}

              {/* Email Input Box */}
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  height: "48px",
                  marginBottom: "16px",
                  overflow: "hidden",
                  backgroundColor: "white",
                }}
              >
                <Box
                  style={{
                    width: "52px",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid #e0e0e0",
                    flexShrink: 0,
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill={primaryColor || '#EB5C24'}>
                    <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"/>
                  </svg>
                </Box>
                <input
                  type="email"
                  placeholder="Enter your email address (optional)"
                  name="email_id"
                  value={formValues?.email_id || ""}
                  onChange={handleChange}
                  style={{
                    flex: 1,
                    border: "none",
                    outline: "none",
                    padding: "0 16px",
                    fontSize: "15px",
                    fontFamily: "Satoshi, sans-serif",
                    color: "#333",
                    height: "100%",
                    backgroundColor: "transparent",
                  }}
                />
              </Box>
            </Box>

            {(() => {
              const showSkip = ((skipOtp === true || skipOtp === "true" || skipOtp === "yes") || (guestCustomer === true || guestCustomer === "true" || guestCustomer === "yes")) && type?.toLowerCase() !== "delivery" && (() => {
                 try {
                   return sessionReducer?.is_fsr !== true;
                 } catch (e) {
                   return true;
                 }
               })();

              return (
                <Box display="flex" flexDirection="row" justifyContent="space-between">
                  {showSkip && (
                    <Button
                      variant="outlined"
                      style={{
                        flex: '0 0 30%',
                        marginRight: '20px',
                        color: primaryColor || '#EB5C24',
                        borderColor: primaryColor || '#EB5C24',
                        padding: '8px',
                        borderRadius: '8px',
                        fontSize: '16px',
                        fontWeight: 600,
                        fontFamily: "Satoshi",
                        textTransform: 'none'
                      }}
                      onClick={() => {
                        setOpenUserInfo(false);
                        navigate("/cart");
                        props.set_customer({ guest: "Guest" });
                      }}
                    >
                      Skip
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    style={{
                      flex: 1,
                      backgroundColor: primaryColor || '#EB5C24',
                      color: 'white',
                      padding: '8px',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: 600,
                      fontFamily: "Satoshi",
                      textTransform: 'none'
                    }}
                    onClick={SaveUserInfo}
                  >
                    {errormsg ? "Sign Up" : "Continue"}
                  </Button>
                </Box>
              );
            })()}
          </>
        ) : (
          <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              <Typography variant="h6" style={{ color: primaryColor || '#EB5C24', fontWeight: 600, fontFamily: "Satoshi" }}>
                Verify OTP
              </Typography>
              <CloseIcon style={{ color: primaryColor || '#EB5C24', cursor: "pointer" }} onClick={handleDrawerClose} />
            </Box>
            <Typography style={{ color: '#666', fontSize: '14px', marginBottom: '24px', fontFamily: "Satoshi" }}>
              Enter the otp sent to +91-{custMoile}
            </Typography>
            
            <Box display="flex" justifyContent="center" mb={3}>
              <OtpInput
                inputStyle={{
                  height: "3rem",
                  width: "3rem",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  fontSize: "1.2rem",
                }}
                value={verificationnumber}
                onChange={setVerificationnumber}
                inputType="tel"
                numInputs={6}
                renderSeparator={<span>&nbsp;&nbsp;</span>}
                renderInput={(props) => <input {...props} className="no-spinners" />}
              />
            </Box>
            {(verificationError || emptyVerification) && (
              <Typography variant="caption" color="error" align="center" display="block" style={{ marginBottom: "16px" }}>
                {verificationError ? "Verification code is incorrect" : "Enter Complete Verification code"}
              </Typography>
            )}

            <Box display="flex" justifyContent="center" mb={3}>
              {seconds > 0 || minutes > 0 ? (
                <Typography variant="body2" style={{ color: "red", fontFamily: "Satoshi" }}>
                  Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                </Typography>
              ) : (
                <Typography variant="body2" style={{ fontFamily: "Satoshi" }}>
                  Didn't receive code? <span style={{ color: primaryColor || '#EB5C24', cursor: "pointer", fontWeight: 600 }} onClick={resendOTP}>Resend OTP</span>
                </Typography>
              )}
            </Box>

            <Button
              variant="contained"
              fullWidth
              style={{
                backgroundColor: primaryColor || '#EB5C24',
                color: 'white',
                padding: '12px',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: 600,
                fontFamily: "Satoshi",
                textTransform: 'none'
              }}
              onClick={RegisterCustomer}
            >
              Verify
            </Button>
          </>
        )}
      </Dialog>
    );
  }

  return (
<SwipeableDrawer
  anchor="bottom"
  open={openUserInfo}
  onClose={handleDrawerClose}
  onOpen={() => setOpenUserInfo(true)}
  disableSwipeToOpen={true}
  classes={{
    paper: classes.drawerPaper,
  }}
  PaperProps={{
    style: {
      // drawerMaxHeight is React state — updates on keyboard open/close
      // on both Android (window.resize) and iOS (visualViewport.resize)
      maxHeight: `${drawerMaxHeight}px`,
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    },
  }}
  disableSwipeToOpen={true}
  disableDiscovery={true}
  ModalProps={{
    BackdropProps: {
      style: { touchAction: "none" },
    },
  }}
>
      <Box className={classes.drawerContent}>
        <Box className={classes.scrollableContent}>
          {!customerRegistration ? (
            <>
              <Grid
                style={{
                  fontFamily: "satoshi",
                  backgroundColor: "white",
                  boxShadow: " rgba(0, 0, 0, 0.08) 0px 2px 12px",
                  textAlign: "left",
                  color: "black",
                  padding: "1rem",
                  marginBottom: "1.5rem",
                  fontWeight: "bold",
                }}
              >
                {" "}
                <Grid item xs={10}>
                  <Typography
                    variant="h6"
                    align="left"
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                    }}
                  >
                    <b>Sign In with Phone Number</b>
                  </Typography>
                  <Typography
                   variant="caption"
                    align="left"
                    style={{
                      fontFamily: "Satoshi",
                      lineHeight: "1",
                    }}
                  >
                    <span style={{ fontWeight: "400", fontSize: "12px", lineHeight: "1" }}>
                      {" "}
                      {storeInfoConfig?.web_ordering_setting?.customer_screen_subline ||
                        (skipOtp
                          ? "Enter your phone no. to proceed."
                          : "We will send an OTP to your phone for signing in")}
                    </span>
                  </Typography>
                </Grid>{" "}
                <Grid item xs={2}>
                  <CloseIcon
                    style={{
                      position: "absolute",
                      top: "1.3rem",
                      right: "11px",
                    }}
                    onClick={() => {
                      setOpenUserInfo(false);
               
                    }}
         
                  />
                          
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    position="relative"
                  >
                <TextField
                  className="bold-placeholder"
                  style={{
                    width: "90%",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                  }}
                  InputProps={{
                    disableUnderline: true,
                    style: { padding: "10px" },
                  }}
                  name="cust_mobile"
                  type="number"
                  onInput={(e) => {
                    e.target.value = Math.max(0, parseInt(e.target.value))
                      .toString()
                      .slice(0, phoneLength);
                  }}
                  onChange={(e) => {
                    setCustMoile(e.target.value);
                    if (e.target.value?.length < phoneLength) {
                      setFormValues({ ...formValues, cust_first_name: "" });
                    }
                  }}
                  value={custMoile}
                  placeholder="Enter phone number"
                />
                    {custMoile && (
                      <button
                        style={{
                          position: "absolute",
                          right: "6%",
                          top: "50%",
                          transform: "translateY(-50%)",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                        }}
                        onClick={() => setCustMoile("")}
                      >
                        <CloseIcon style={{ color: "black" }} />
                      </button>
                    )}
                  </Box>
                  {phoneNumbermsg && (
                    <Typography
                      variant="caption"
                      color="error"
                      display="block"
                      align="left"
                      style={{ marginTop: "0.5rem", marginLeft: "5.5%" }}
                    >
                      <span style={{ fontSize: "11px" }}>
                        Phone number is required
                      </span>
                    </Typography>
                  )}
                </Grid>
                {/* Name Input - Always visible */}
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    position="relative"
                  >
                  <TextField
                    className="bold-placeholder"
                    style={{
                      width: "90%",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                    InputProps={{
                      disableUnderline: true,
                      style: { padding: "10px" },
                    }}
                    name="cust_first_name"
                    onChange={handleChange}
                    value={formValues?.cust_first_name || ""}
                    placeholder="Enter your name"
                  />
                    {formValues?.cust_first_name && (
                      <button
                        style={{
                          position: "absolute",
                          right: "6%",
                          top: "50%",
                          transform: "translateY(-50%)",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                        }}
                        onClick={handleClearField}
                      >
                        <CloseIcon style={{ color: "black" }} />
                      </button>
                    )}
                  </Box>
                  {(namefieldmsg || errormsg) && (
                    <Typography
                      variant="caption"
                      color="error"
                      display="block"
                      align="left"
                      style={{ marginTop: "0.5rem", marginLeft: "5.5%" }}
                    >
                      <span style={{ fontSize: "11px" }}>
                        {namefieldmsg ? "Name is required" : errormsg ? "" : ""}
                      </span>
                    </Typography>
                  )}
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <Grid
                style={{
                  fontFamily: "satoshi",
                  backgroundColor: "white",
                  boxShadow: " rgba(0, 0, 0, 0.08) 0px 2px 12px",
                  textAlign: "left",
                  color: "black",
                  padding: "1rem",
                  marginBottom: "1.5rem",
                  fontWeight: "bold",
                }}
              >
                {" "}
                <Grid item xs={10}>
                  <Typography
                    variant="h6"
                    align="left"
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                    }}
                  >
                    <b>Verify OTP</b>
                  </Typography>
                  <Typography
                    align="left"
                    style={{
                      fontFamily: "Satoshi",
                    }}
                  >
                    <span style={{ fontSize: "12px" }}>+91-{custMoile}</span>
                  </Typography>
                </Grid>{" "}
                <Grid item xs={2}>
                  <CloseIcon
                    style={{
                      position: "absolute",
                      top: "1.3rem",
                      right: "11px",
                    }}
                    onClick={() => {
                      setOpenUserInfo(false);
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  {/* <Typography
                    variant="h6"
                    align="center"
                    style={{ fontWeight: "bold", marginBottom: "1rem" }}
                  >
                    Verify OTP
                  </Typography>
                  <Typography
                    align="center"
                    style={{ fontWeight: "bold", marginBottom: "0.5rem" }}
                  >
                    +91-{custMoile}
                  </Typography> */}
                  <Typography
                    align="center"
                    style={{ marginBottom: "1rem", fontSize: "14px" }}
                  >
                    Enter the otp in the box below to continue
                  </Typography>
                </Grid>

                {/* OTP Input */}
                <Grid item xs={12}>
                  <Box display="flex" justifyContent="center">
                    <OtpInput
                      inputStyle={{
                        height: "2.5rem",
                        width: "2.5rem",
                        border: "1px solid grey",
                        borderRadius: "0.4rem",
                        fontSize: "1rem",
                      }}
                      value={verificationnumber}
                      onChange={setVerificationnumber}
                      inputType="tel"
                      numInputs={6}
                      renderSeparator={<span>&nbsp;&nbsp;</span>}
                      renderInput={(props) => <input {...props} className="no-spinners" />}
                    />
                  </Box>
                  {(verificationError || emptyVerification) && (
                    <Typography
                      variant="caption"
                      color="error"
                      display="block"
                      align="center"
                      style={{ marginTop: "0.5rem" }}
                    >
                      {verificationError && "Verification code is incorrect"}
                      {emptyVerification && "Enter Complete Verification code"}
                    </Typography>
                  )}
                </Grid>

                {/* Timer and Resend */}
                <Grid item xs={12}>
                  <Box display="flex" justifyContent="center">
                    {seconds > 0 || minutes > 0 ? (
                      <Typography variant="caption" style={{ color: "red", fontSize: "14px" }}>
                        Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}
                        :{seconds < 10 ? `0${seconds}` : seconds}
                      </Typography>
                    ) : (
                      <Typography variant="caption">
                        <span style={{ fontSize: "12px" }}>
                          {" "}
                          Didn't receive code?{" "}
                        </span>
                        <span
                          style={{
                            color: "#FF5630",
                            cursor: "pointer",
                            textDecoration: "none",
                            fontSize: "12px",
                          }}
                          onClick={resendOTP}
                        >
                          Resend OTP
                        </span>
                      </Typography>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </>
          )}
        </Box>

        {/* Button always visible at bottom — flexbox keeps it pinned */}
<Box
  className={classes.stickyButton}
  style={{
    background: "#fff",
  }}
>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-around",
              gap: "10px",
              padding: "16px 5%",
              paddingBottom: "calc(16px + env(safe-area-inset-bottom, 0px))",
              boxShadow: "rgba(0, 0, 0, 0.05) 0px -2px 10px",
            }}
            display="flex"
            justifyContent="center"
          >
            {((skipOtp === true || skipOtp === "true" || skipOtp === "yes") || (guestCustomer === true || guestCustomer === "true" || guestCustomer === "yes")) && !customerRegistration && type?.toLowerCase() !== "delivery" && (() => {
               try {
                 return sessionReducer?.is_fsr !== true;
               } catch (e) {
                 return true;
               }
             })() ? 
            <Button
              variant="contained"
              style={{
                fontSize: "1.3rem",
                borderRadius: "8px",
                padding: "12px 0px",
                color: "black",
                width: "30%",
                background: "white",
              }}
              onClick={() =>   setOpenUserInfo(false)+ 
                navigate("/cart") +   props.set_customer({ guest: "Guest" })
              }
            >
              Skip
            </Button> :""}
            <Button
              variant="contained"
              style={{
                fontSize: "1.3rem",
                borderRadius: "8px",
                // padding: "12px 0px",
                minWidth: "70%",
                color:  "white" || TEXT_COLOR,
                backgroundColor:primaryColor || BUTTON_COLOR,
              }}
              onClick={customerRegistration ? RegisterCustomer : SaveUserInfo}
            >
              {customerRegistration
                ? "Verify"
                : errormsg
                ? "Sign Up"
                : "Continue"}
            </Button>
          </Box>
        </Box>
      </Box>
    </SwipeableDrawer>
  );
};

const mapStateToProps = (state) => {
  return {
    cartProps: state.cartReducer,
    reducer: state.customerReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    set_customer: (obj) => {
      dispatch(set_customer(obj));
    },
    set_last_order: (obj) => {
      dispatch(set_last_order(obj));
    },
    customer_membership: (obj) => {
      dispatch(customer_membership(obj));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginDrawer);
